import { registerInferredProjectPopupContent } from '@atlassian/rovo-platform-ui-components/inferred-project-popup-content';

import { InferredProjectPopupContent } from './InferredProjectPopupContent.tsx';

/** Lets the For You suggested projects in Rovo Chat open their popup. Call it where Chat mounts. */
export const registerInferredProjectPopup = (): void =>
	registerInferredProjectPopupContent(InferredProjectPopupContent);
